interface ProfileSectionsAccessParams {
  isCustomer: boolean
  isAffiliate: boolean
  isStudent: boolean
  isWorkspaceOwner: boolean
}

// Settings → Profile merged the former Profile and Account pages, so each keeps its own audience:
// the profile details stay with workspace owners, the time settings with every customer or student
export function getProfileSectionsAccess({
  isCustomer,
  isAffiliate,
  isStudent,
  isWorkspaceOwner,
}: ProfileSectionsAccessParams) {
  return {
    canEditProfileDetails: (isCustomer || isAffiliate) && isWorkspaceOwner,
    canEditTimeSettings: isCustomer || isStudent,
  }
}
